import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib/store';
import * as actions from './get-emd-passenger-receipt.actions';
import { GetEmdPassengerReceiptState } from './get-emd-passenger-receipt.state';

/**
 * getEmdPassengerReceipt initial state
 */
export const getEmdPassengerReceiptInitialState: GetEmdPassengerReceiptState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for GetEmdPassengerReceipt Store
 */
export const getEmdPassengerReceiptReducerFeatures: ReducerTypes<GetEmdPassengerReceiptState, ActionCreator[]>[] = [
  on(actions.setGetEmdPassengerReceipt, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateGetEmdPassengerReceipt, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetGetEmdPassengerReceipt, () => getEmdPassengerReceiptInitialState),

  on(actions.cancelGetEmdPassengerReceiptRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failGetEmdPassengerReceipt, (state, payload) =>
    asyncStoreItemAdapter.failRequest(state, payload.requestId)
  ),

  on(actions.setGetEmdPassengerReceiptFromApi, actions.updateGetEmdPassengerReceiptFromApi, (state, payload) =>
    asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * GetEmdPassengerReceipt Store reducer
 */
export const getEmdPassengerReceiptReducer = createReducer(
  getEmdPassengerReceiptInitialState,
  ...getEmdPassengerReceiptReducerFeatures
);
